import $ from 'jquery';
// import Utils from './utilities';

// import 'jquery-gray';
/* global x5script */

class Misc {
  constructor() {
    // this.utilities = new Utils();
    this.backButton = $('.js-back-button');
    this.videoEmbed = $('.c-embed--video');
    this.clearWBSession = x5script.clearWizardBlockSession;

    this.backButtonSetup();
    this.videoWrapper();
    this.clearWizardBlockSession();

    setTimeout(() => {
      this.promoBars = $('.njt-nofi-notification-bar, .mtsnb-shown');
      this.promoBarsPosition();
    }, 1000);
  }

  backButtonSetup() {
    $.each(this.backButton, (i, el) => {
      const button = $(el);

      if (button.length) {
        button.css({ visibility: 'visible' });
      }

      button.on('click', e => {
        const self = $(e.currentTarget);

        if (window.history.length > 1) {
          window.history.back();
        } else if (self.hasClass('is-blog-back-button')) {
          window.location.replace(x5script.blogUrl);
        }
      });
    });
  }

  setHeaderPosition() {
    // const height = this.utilities.getMaxHeight(this.promoBars[0]);
    const height = this.promoBar.outerHeight();

    this.header.css({
      top: this.headerPos + height,
    });
  }

  promoBarsPosition() {
    if (this.promoBars.length) {
      this.promoBar = $(this.promoBars[0]);
      this.header = $('.js-header');
      this.headerPos = parseInt(this.header.css('top'), 10);
      this.setHeaderPosition();
      this.promoBar.stop().animate({ opacity: 1 }, 500);

      this.promoBar
        .closest('.njt-nofi-container')
        .find('.njt-nofi-display-toggle')
        .on('click', () => {
          setTimeout(() => {
            this.setHeaderPosition();
          }, 400);
        });

      this.promoBar
        .find('.mtsnb-hide, .njt-nofi-close-button, .njt-nofi-toggle-button')
        .on('click', e => {
          const self = $(e.currentTarget);

          setTimeout(() => {
            this.header.css({
              top: this.headerPos,
            });
          }, self.hasClass('mtsnb-hide') ? 0 : 400);
        });
    }
  }

  videoWrapper() {
    if (this.videoEmbed.length) {
      $.each(this.videoEmbed, (i, el) => {
        const embed = $(el);

        if (!embed.parent().hasClass('c-embed-wrapper')) {
          embed.wrap('<div class="c-embed-wrapper"></div>');
        }
      });
    }
  }

  clearWizardBlockSession() {
    if (this.clearWBSession) {
      sessionStorage.removeItem('compareUrlQuery');
    }
  }
}

export default new Misc();



// WEBPACK FOOTER //
// ./src/scripts/modules/misc.js